var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app flex-row align-items-center"
  }, [_c('vue-progress-bar'), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-group mb-0"
  }, [_c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "is-full-page": false
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card p-3"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('p', {
    staticClass: "text-muted"
  }, [_vm._v("Identitas Perusahaan")]), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('No Id Perusahaan')),
      expression: " errors.has( 'No Id Perusahaan' ) "
    }],
    staticClass: "text-danger"
  }, [_vm._v("\n                " + _vm._s(_vm.errors.first('No Id Perusahaan')) + "\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "input-group mb-3"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("Identitas")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.perkdid),
      expression: " form.perkdid "
    }],
    staticClass: "form-control",
    attrs: {
      "name": "kdid"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.form.perkdid = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "5"
    }
  }, [_vm._v("NPWP")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("KTP")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("Paspor")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("Lainnya")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (_vm.form.perkdid === '5' ? 'required|min:16' : 'required'),
      expression: "form.perkdid === '5' ? 'required|min:16' : 'required' "
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.form.perid),
      expression: " form.perid "
    }],
    staticClass: "form-control",
    attrs: {
      "name": "No Id Perusahaan",
      "type": "text",
      "placeholder": "No Identitas"
    },
    domProps: {
      "value": (_vm.form.perid)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.perid = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group mb-3"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("Upload Identitas")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.chfileperid
    }
  })]), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Nama Perusahaan')),
      expression: " errors.has( 'Nama Perusahaan' ) "
    }],
    staticClass: "text-danger"
  }, [_vm._v("\n                " + _vm._s(_vm.errors.first('Nama Perusahaan')) + "\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "input-group mb-3"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: " 'required' "
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.form.pernama),
      expression: " form.pernama "
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Nama Perusahaan",
      "type": "text",
      "placeholder": "Nama Perusahaan"
    },
    domProps: {
      "value": (_vm.form.pernama)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.pernama = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Alamat Perusahaan')),
      expression: " errors.has( 'Alamat Perusahaan' ) "
    }],
    staticClass: "text-danger"
  }, [_vm._v("\n                " + _vm._s(_vm.errors.first('Alamat Perusahaan')) + "\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "input-group mb-3"
  }, [_vm._m(2), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: " 'required' "
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.form.peralamat),
      expression: " form.peralamat "
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Alamat Perusahaan",
      "type": "text",
      "placeholder": "Alamat Perusahaan"
    },
    domProps: {
      "value": (_vm.form.peralamat)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.peralamat = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('No Telepon Perusahaan')),
      expression: " errors.has( 'No Telepon Perusahaan' ) "
    }],
    staticClass: "text-danger"
  }, [_vm._v("\n                " + _vm._s(_vm.errors.first('No Telepon Perusahaan')) + "\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "input-group mb-3"
  }, [_vm._m(3), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:15|min:3'),
      expression: " 'required|max:15|min:3' "
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.form.pernotelp),
      expression: " form.pernotelp "
    }],
    staticClass: "form-control",
    attrs: {
      "name": "No Telepon Perusahaan",
      "type": "text",
      "placeholder": "No Telepon Perusahaan"
    },
    domProps: {
      "value": (_vm.form.pernotelp)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.pernotelp = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Email Perusahaan')),
      expression: " errors.has( 'Email Perusahaan' ) "
    }],
    staticClass: "text-danger"
  }, [_vm._v("\n                " + _vm._s(_vm.errors.first('Email Perusahaan')) + "\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "input-group mb-3"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("@")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: " 'required|email' "
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.form.peremail),
      expression: " form.peremail "
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Email Perusahaan",
      "type": "text",
      "placeholder": "Email Perusahaan"
    },
    domProps: {
      "value": (_vm.form.peremail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.peremail = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group mb-3"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("Akses Kepabeanan")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.perakses),
      expression: " form.perakses "
    }],
    staticClass: "form-control",
    attrs: {
      "name": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.form.perakses = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "N",
      "selected": "true"
    }
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Y"
    }
  }, [_vm._v("PENGANGKUT")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Y"
    }
  }, [_vm._v("PPJK")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "N"
    }
  }, [_vm._v("IMPORTIR")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "N"
    }
  }, [_vm._v("EKSPORTIR")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "N"
    }
  }, [_vm._v("PERORANGAN")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "S"
    }
  }, [_vm._v("PENGUSAHA TPS/KP/BKC/")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "N"
    }
  }, [_vm._v("PENGUSAHA JASA TITIPAN")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "M"
    }
  }, [_vm._v("PPFTZ Manual")])])]), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('username')),
      expression: " errors.has( 'username' ) "
    }],
    staticClass: "text-danger"
  }, [_vm._v("\n                " + _vm._s(_vm.errors.first('username')) + "\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "input-group mb-3"
  }, [_vm._m(4), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: " 'required' "
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.form.username),
      expression: " form.username "
    }],
    staticClass: "form-control",
    attrs: {
      "name": "username",
      "type": "text",
      "placeholder": "Username"
    },
    domProps: {
      "value": (_vm.form.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.username = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('password')),
      expression: " errors.has( 'password' ) "
    }],
    staticClass: "text-danger"
  }, [_vm._v("\n                " + _vm._s(_vm.errors.first('password')) + "\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "input-group mb-3"
  }, [_vm._m(5), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: " 'required' "
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.form.password),
      expression: " form.password "
    }],
    staticClass: "form-control",
    attrs: {
      "name": "password",
      "type": "password",
      "placeholder": "Password"
    },
    domProps: {
      "value": (_vm.form.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.password = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "card p-3"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('p', {
    staticClass: "text-muted"
  }, [_vm._v("Identitas Pendaftar")]), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('No Identitas Pendaftar')),
      expression: " errors.has( 'No Identitas Pendaftar' ) "
    }],
    staticClass: "text-danger"
  }, [_vm._v("\n                " + _vm._s(_vm.errors.first('No Identitas Pendaftar')) + "\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "input-group mb-3"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("Identitas")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.dafkdid),
      expression: " form.dafkdid "
    }],
    staticClass: "form-control",
    attrs: {
      "name": "kdid"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.form.dafkdid = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "5"
    }
  }, [_vm._v("NPWP")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("KTP")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("Paspor")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("Lainnya")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (_vm.form.dafkdid === '5' ? 'required|min:16' : 'required'),
      expression: "form.dafkdid === '5' ? 'required|min:16' : 'required' "
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.form.dafid),
      expression: " form.dafid "
    }],
    staticClass: "form-control",
    attrs: {
      "name": "No Identitas Pendaftar",
      "type": "text",
      "placeholder": "No Identitas Pendaftar"
    },
    domProps: {
      "value": (_vm.form.dafid)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.dafid = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group mb-3"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("Upload Identitas")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.chfiledafid
    }
  })]), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Nama Pendaftar')),
      expression: " errors.has( 'Nama Pendaftar' ) "
    }],
    staticClass: "text-danger"
  }, [_vm._v("\n                " + _vm._s(_vm.errors.first('Nama Pendaftar')) + "\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "input-group mb-3"
  }, [_vm._m(6), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: " 'required' "
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.form.dafnama),
      expression: " form.dafnama "
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Nama Pendaftar",
      "type": "text",
      "placeholder": "Nama Pendaftar"
    },
    domProps: {
      "value": (_vm.form.dafnama)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.dafnama = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Alamat Pendaftar')),
      expression: " errors.has( 'Alamat Pendaftar' ) "
    }],
    staticClass: "text-danger"
  }, [_vm._v("\n                " + _vm._s(_vm.errors.first('Alamat Pendaftar')) + "\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "input-group mb-3"
  }, [_vm._m(7), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: " 'required' "
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.form.dafalamat),
      expression: " form.dafalamat "
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Alamat Pendaftar",
      "type": "text",
      "placeholder": "Alamat Pendaftar"
    },
    domProps: {
      "value": (_vm.form.dafalamat)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.dafalamat = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('No Telepon Pendaftar')),
      expression: " errors.has( 'No Telepon Pendaftar' ) "
    }],
    staticClass: "text-danger"
  }, [_vm._v("\n                " + _vm._s(_vm.errors.first('No Telepon Pendaftar')) + "\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "input-group mb-3"
  }, [_vm._m(8), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:15|min:3'),
      expression: " 'required|max:15|min:3' "
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.form.dafnotelp),
      expression: " form.dafnotelp "
    }],
    staticClass: "form-control",
    attrs: {
      "name": "No Telepon Pendaftar",
      "type": "text",
      "placeholder": "No Telepon Pendaftar (Contoh: 081234567890)"
    },
    domProps: {
      "value": (_vm.form.dafnotelp)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.dafnotelp = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Email Pendaftar')),
      expression: " errors.has( 'Email Pendaftar' ) "
    }],
    staticClass: "text-danger"
  }, [_vm._v("\n                " + _vm._s(_vm.errors.first('Email Pendaftar')) + "\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "input-group mb-3"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("@")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: " 'required|email' "
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.form.dafemail),
      expression: " form.dafemail "
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Email Pendaftar",
      "type": "text",
      "placeholder": "Email Pendaftar"
    },
    domProps: {
      "value": (_vm.form.dafemail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.dafemail = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('File Surat Pernyataan')),
      expression: " errors.has( 'File Surat Pernyataan' ) "
    }],
    staticClass: "text-danger"
  }, [_vm._v("\n                " + _vm._s(_vm.errors.first('File Surat Pernyataan')) + "\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "input-group mb-3"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("Surat Pernyataan")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: " 'required' "
    }],
    staticClass: "form-control",
    attrs: {
      "type": "file",
      "name": "File Surat Pernyataan"
    },
    on: {
      "change": _vm.chsuratpernyataan
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group mb-3"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("Surat Kuasa")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "file",
      "name": "File Surat Kuasa"
    },
    on: {
      "change": _vm.chsuratkuasa
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group mb-3"
  }, [_c('div', {
    staticClass: "input-group mb-3"
  }, [_c('vue-recaptcha', {
    attrs: {
      "sitekey": _vm.sitekey
    },
    on: {
      "verify": _vm.onCaptchaVerified,
      "expired": _vm.onCaptchaExpired
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "card-footer p-3"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('button', {
    staticClass: "btn btn-block btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.sendregis
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" Create Account")])]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('router-link', {
    staticClass: "btn btn-block btn-danger",
    attrs: {
      "to": '/login'
    }
  }, [_c('i', {
    staticClass: "fa fa-remove"
  }), _vm._v(" Cancel\n                    ")])], 1)])])])])], 1)])])])], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('h1', [_vm._v("Register")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-address-card"
  })])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-home"
  })])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-phone"
  })])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "icon-user"
  })])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "icon-lock"
  })])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-address-card"
  })])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-home"
  })])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-phone"
  })])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dfc97aa8","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Register.vue
// module id = 167
// module chunks = 0